import { Box, Button, Grid } from "@mui/material";
import { ArtifactStyle } from "./VerficationArtifactsStyles";
import { useVerification } from "../../../../../context/Verification.context";
import Theme from "../../../../../utils/Theme";
import { useEffect, useRef, useState } from "react";
import SurveyMicComponent from "./SurveyMic.component";
import TextUnAvailable from "./TextUnAvailable";

const SurveyResponse = ({
  artifact,
  manageArtifactResponse,
  setSurveyScreen,
  isAISurvey = false,
  onStepInteraction,
  // isOtherSelected,
  // setIsOtherSelected,
}) => {
  const verification = useVerification();
  const [message, setMessage] = useState("");
  const [instructionVideoCompleted, setInstructionVideoCompleted] =
    useState(false);
  const instructionVideoRef = useRef(null);

  const instructionVideoDone =
    instructionVideoCompleted ||
    Boolean(
      verification?.aiData?.instructionVideoCompletedByArtifact?.[artifact?.id],
    );

  const otherArtifact = verification?.tradeQuote?.find(
    (item) => item?.typeName === "surveyOther",
  );
  const instructionVideoUrl = verification?.aiData?.spanish
    ? otherArtifact?.ai_url?.spanish_url
    : otherArtifact?.ai_url?.english_url;
  const hasInstructionVideo =
    instructionVideoUrl &&
    instructionVideoUrl !== "null" &&
    instructionVideoUrl !== "";

  const isQuestionAnswered = (questionId, option) => {
    if (verification?.artifactsResponse?.surveyResponse?.length > 0) {
      const getOption = verification.artifactsResponse.surveyResponse.filter(
        (ans) => ans?.question_id === questionId && ans?.answer === option,
      );
      return getOption[0]?.answer;
    }
    return false;
  };

  const handleAnswer = (questionId, answer) => {
    onStepInteraction?.();

    const isother =
      answer === "OTHER" ||
      answer === "Other" ||
      answer === "Otro" ||
      answer === "OTRO" ||
      answer === "otro" ||
      answer === "other";

    verification?.setArtifactsResponse?.((prevResponse) => {
      const newSurveyResponse = {
        user_id: parseInt(verification?.customer?.userId),
        question_id: questionId,
        answer: answer,
        created_by: parseInt(verification.employeeId),
        updated_by: parseInt(verification.employeeId),
        isCurrent: true,
        isOther: isother,
      };

      const surveyResponses = prevResponse?.surveyResponse || [];
      const existingResponse = surveyResponses.find(
        (response) => response.question_id === newSurveyResponse.question_id,
      );
      console.log("existingResponse", existingResponse, surveyResponses);
      if (existingResponse) {
        const updatedSurveyResponses = surveyResponses.map((response) =>
          response.question_id === newSurveyResponse.question_id
            ? { ...newSurveyResponse, id: existingResponse?.id }
            : response,
        );
        return { ...prevResponse, surveyResponse: updatedSurveyResponses };
      } else {
        return {
          ...prevResponse,
          surveyResponse: [...surveyResponses, newSurveyResponse],
        };
      }
    });

    setSurveyScreen(true);
  };

  const esOptions = JSON.parse(artifact?.es_options || "[]");
  const enOptions = JSON.parse(artifact?.options || "[]");

  useEffect(() => {
    if (message) {
      verification?.setArtifactsResponse?.((prevResponse) => {
        const newSurveyResponse = {
          user_id: parseInt(verification?.customer?.userId),
          question_id: artifact.id,
          answer: message,
          created_by: parseInt(verification.employeeId),
          updated_by: parseInt(verification.employeeId),
          isCurrent: true,
          isOther: true,
        };

        const surveyResponses = prevResponse?.surveyResponse || [];
        const existingResponse = surveyResponses.find(
          (response) => response.question_id === newSurveyResponse.question_id,
        );

        if (existingResponse) {
          const updatedSurveyResponses = surveyResponses.map((response) =>
            response.question_id === newSurveyResponse.question_id
              ? { ...newSurveyResponse, id: existingResponse?.id }
              : response,
          );
          return { ...prevResponse, surveyResponse: updatedSurveyResponses };
        } else {
          return {
            ...prevResponse,
            surveyResponse: [...surveyResponses, newSurveyResponse],
          };
        }
      });

      setSurveyScreen(true);
    }
  }, [message]);

  const displayOptions = verification.aiData.spanish ? esOptions : enOptions;

  const isOther = verification?.aiData?.isOther;
  const isSpokepersonMode = Boolean(verification?.aiData?.spokeperson);
  const showInstructionVideo =
    !isAISurvey &&
    isOther &&
    hasInstructionVideo &&
    !instructionVideoDone &&
    isSpokepersonMode;
  const showMicUI =
    isOther &&
    (instructionVideoDone || !hasInstructionVideo || !isSpokepersonMode);

  // 2 options per row (2x2 for 4 options); if the option count is odd,
  // the last item spans the full row.
  const getOptionGridSize = (index) =>
    enOptions.length % 2 !== 0 && index === enOptions.length - 1 ? 12 : 6;

  // Shared option-button styling used by BOTH avatar mode and read mode
  // so the two experiences render identical option buttons.
  const renderOptionButton = (option) => (
    <Button
      sx={{
        width: isAISurvey
          ? "100%"
          : window.innerWidth <= 750
            ? "260px"
            : "100%",
        height: window.innerWidth <= 750 ? "40px" : "50px",
        border: "2px solid #009349",
        borderRadius: 2,
        fontWeight: "bold",
        fontSize: window.innerWidth <= 750 ? 12 : null,
        bgcolor:
          isQuestionAnswered(artifact.id, option) === option
            ? null
            : "white",
        "&:hover": {
          bgcolor: Theme.palette.primary.main,
          color: "white",
        },
      }}
      variant={
        isQuestionAnswered(artifact.id, option) === option
          ? "contained"
          : "outlined"
      }
      onClick={() => {
        if (
          option === "OTHER" ||
          option === "Other" ||
          option === "Otro" ||
          option === "OTRO" ||
          option === "otro" ||
          option === "other"
        ) {
          verification.setAIData((prev) => ({
            ...prev,
            isOther: true,
          }));
          // setIsOtherSelected(true);
          handleAnswer(artifact.id, option);
        } else {
          handleAnswer(artifact.id, option);
        }
      }}
    >
      {option}
    </Button>
  );

  return (
    <>
      {isAISurvey ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
            alignItems: "center",
            p: 1,
          }}
        >
          {showMicUI ? (
            <Box sx={{ display: "flex" }}>
              <SurveyMicComponent
                artifactId={artifact?.id}
                message={message}
                setMessage={setMessage}
                isAISurvey={isAISurvey}
              />
            </Box>
          ) : isOther ? null : (
            <Grid container spacing={2} sx={{ display: "flex", px: 1 }}>
              {displayOptions?.map((option, index) => (
                <Grid
                  item
                  xs={getOptionGridSize(index)}
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {option && renderOptionButton(option)}
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      ) : (
        <Box sx={ArtifactStyle.surveyOutBox}>
          {showInstructionVideo ? (
            <Box
              sx={{
                width: "100%",
                maxHeight: 320,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              <video
                ref={instructionVideoRef}
                playsInline
                autoPlay
                controls
                preload="auto"
                style={{
                  width: "100%",
                  maxHeight: 320,
                  objectFit: "contain",
                }}
                onEnded={() => {
                  setInstructionVideoCompleted(true);
                  verification?.setAIData?.((prev) => ({
                    ...prev,
                    instructionVideoCompletedByArtifact: {
                      ...prev?.instructionVideoCompletedByArtifact,
                      [artifact?.id]: true,
                    },
                  }));
                }}
                src={instructionVideoUrl}
              >
                Your browser does not support the video.
              </video>
            </Box>
          ) : showMicUI ? (
            <SurveyMicComponent
              artifactId={artifact?.id}
              message={message}
              setMessage={setMessage}
            />
          ) : (
            <>
              <TextUnAvailable
                text={artifact?.question}
                es_text={artifact?.es_question}
              />
              <Grid container spacing={2} sx={{ display: "flex", px: 3 }}>
                {displayOptions?.map((option, index) => (
                  <Grid
                    item
                    xs={getOptionGridSize(index)}
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {option && renderOptionButton(option)}
                  </Grid>
                ))}
              </Grid>
            </>
          )}
        </Box>
      )}
    </>
  );
};

export default SurveyResponse;